module.exports = __webpack_public_path__ + "static/figure_vizcomm-home-4567e3eae9fc9d2d5171c1897935c343.png";